/**
 * Created by Administrador on 11/26/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('depot', {
                parent: 'app',
                url: '/depot',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/cargo/depot/depot.html',
                        controller: 'depotCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabCargoOperationReport('depot')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['cargoReport', 'subClassification']);
                            }],
                            'cities': ['cityService', function(cityService){
                                return cityService.getCities()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            subClassifications: ['subClassificationService', function(subClassificationService){
                                return subClassificationService.getSubClassificationList();
                            }]
                        }
                    }
                }
            });
    }
})();
